import React from "react";


import {
  Box,
  Flex,
  Drawer,
  DrawerBody,
  Icon,
  useColorModeValue,
  DrawerOverlay,
  useDisclosure,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";
import Content from "components/sidebar/components/Content";
import Brand from "components/sidebar/components/Brand";
import UserProfileCard from "components/sidebar/components/UserProfileCard";
import {
  renderThumb,
  renderTrack,
  renderView,
} from "components/scrollbar/Scrollbar";
import { Scrollbars } from "react-custom-scrollbars-2";
import PropTypes from "prop-types";

// Assets
import { IoMenuOutline } from "react-icons/io5";
import logoomnidoc from "assets/img/logoomnidoc-white.png";
import { Image, Text } from "@chakra-ui/react";

function Sidebar(props) {
  const { routes } = props;

  let variantChange = "0.2s linear";
  let shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.08)",
    "unset"
  );
  // Chakra Color Mode
  let sidebarBg = "#006133"; // Couleur verte de la sidebar
  let sidebarMargins = "0px";

  // SIDEBAR
  return (
    <Box display={{ sm: "none", xl: "block" }} w="100%" position='fixed' minH='100%'>
      <Box
        bg={sidebarBg}
        transition={variantChange}
        w='240px'
        h='100vh'
        m={sidebarMargins}
        minH='100%'
        overflowX='hidden'
        boxShadow={shadow}
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        borderRadius="0 12px 12px 0"
        borderRight="1px solid #E5E5E5">

        {/* Brand - Fixed at top */}
        <Flex
          h="80px"
          p="25px"
          alignItems="center"
          gap="10px"
          flexShrink={0}
          alignSelf="stretch"
          borderBottom="1px solid rgba(255, 255, 255, 0.10)">
          <Brand />
        </Flex>

        {/* Menu Content - Scrollable */}
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={renderView}
          style={{ flex: 1, width: '100%' }}>
          <Box w="100%" display="flex" flexDirection="column" alignItems="flex-start" p="20px 0">
            <Content routes={routes} />
          </Box>
        </Scrollbars>

        {/* Bottom Section - Fixed at bottom */}
        <Flex direction="column" w="100%" flexShrink={0}>
          <UserProfileCard />
         
        </Flex>
      </Box>
    </Box>
  );
}


export function SidebarResponsive(props) {
  let sidebarBackgroundColor = "#006133"; // Couleur bleue de la sidebar
  let menuColor = "white";

  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  const { routes } = props;


  return (
    <Flex display={{ sm: "flex", xl: "none" }} alignItems='center'>
      <Flex ref={btnRef} w='max-content' h='max-content' onClick={onOpen}>
        <Icon
          as={IoMenuOutline}
          color={menuColor}
          my='auto'
          w='20px'
          h='20px'
          me='10px'
          _hover={{ cursor: "pointer" }}
        />
      </Flex>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement={document.documentElement.dir === "rtl" ? "right" : "left"}
        finalFocusRef={btnRef}>
        <DrawerOverlay />
        <DrawerContent w='240px' maxW='240px' bg={sidebarBackgroundColor}>
          <DrawerCloseButton
            zIndex='3'
            onClose={onClose}
            _focus={{ boxShadow: "none" }}
            _hover={{ boxShadow: "none" }}
          />
          <DrawerBody maxW='240px' px='0rem' pb='0'>
            <Scrollbars
              autoHide
              renderTrackVertical={renderTrack}
              renderThumbVertical={renderThumb}
              renderView={renderView}>
              <Content routes={routes} />
            </Scrollbars>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}
// PROPS

Sidebar.propTypes = {
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  variant: PropTypes.string,
};

export default Sidebar;
